import BaseObject from './BaseObject.js';
import SecondaryMenuItem from './SecondaryMenuItem.js';

export default class PrimaryMenuItem extends BaseObject {
  constructor(id, icon, component, props) {
    super();
    this.id = id;
    this.icon = icon;
    this.children = [];
    this.features = [];

    this.component = component;
    this.props = props;
  }

  get hasChildren() {
    return (this.children || []).length > 0;
  }

  get path() {
    return `/${this.id}`;
  }

  get route() {
    if ((this.component || null) === null) {
      return null;
    }
    return {
      path: this.path,
      name: this.id,
      component: this.component,
      props: this.props,
      meta: {
        verifyAuth: true,
        primary: this.id,
        title: this.id
      }
    };
  }

  RegisterChild(secondary) {
    if (secondary instanceof SecondaryMenuItem) {
      this.children.push(secondary);
      secondary.Registered(this);
    }
  }

  ClearChildren() {
    this.children = [];
    this.features = [];
  }
}
